import React from 'react';

export const EmojiIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M680.5,389a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,680.5,389Zm0-15.937a7.437,7.437,0,1,0,7.437,7.437A7.437,7.437,0,0,0,680.5,373.063ZM681,386h-1a3,3,0,0,1-3-3v-1h7v1A3,3,0,0,1,681,386Zm-3-3a2,2,0,0,0,2,2h1c1.727,0,2-2,2-2h-5Zm4.5-3a0.5,0.5,0,0,1-.5-0.5v-2a0.5,0.5,0,0,1,1,0v2A0.5,0.5,0,0,1,682.5,380Zm-4,0a0.5,0.5,0,0,1-.5-0.5v-2a0.5,0.5,0,0,1,1,0v2A0.5,0.5,0,0,1,678.5,380Z"
      transform="translate(-672 -372)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/emoji-icon.js